<template>
  <div>
    <DataTableWrapper
      ref="tableWrapper"
      :initialSortBy="[{ field: 'createdAt', dir: 'desc' }]"
      :data-source="{
        type: 'AxisGQL',
        query: require('@/services/gql/types/LegalDetail/queries/legalDetails.graphql')
      }"
      :headers="$options.headersConfig"
      :filters="filters"
      :stored-headers="getCurrentViewCols"
      :views-list="getViewList"
      :active-view-key="getActiveViewKey"
      @view-changed="updateStoredView"
      @active-view-changed="updateStoredActiveView"
      @remove-view="removeStoredView"
      @data-loaded="onTableDataChange"
    >
      <template v-slot="{ tableProps, tableListeners, filtersProps, filtersListeners }">
        <v-data-table
          fixed-header
          height="80vh"
          :items-per-page="$options.perPage.itemsPerPage"
          :footer-props="{ itemsPerPageOptions: $options.perPage.itemsPerPageOptions }"
          v-bind="tableProps"
          v-on="tableListeners"
          v-model="mixSelectedItems"
        >
          <template v-for="(h, i) in $options.headersConfig" v-slot:[`header.${h.value}`]>
            <v-tooltip open-delay="350" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ h.text }}</span>
              </template>
              <span>{{ h.description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`body.prepend`]="{}">
            <DataTableFilters
              is-grid-selectable
              v-bind="filtersProps"
              v-on="filtersListeners"
            />
          </template>
          <template
            v-for="(h, i) in $options.headersConfig"
            v-slot:[`item.${h.value}`]="{ item }"
          >
            <div :key="i">
              <div v-if="h.type === 'number' && item[h.value] !== null">
                {{ formatAmount(item[h.value]) }}
              </div>
              <div v-else-if="h.text === 'Заголовок'">
                <router-link
                  title="Редактировать"
                  :to="{
                    name: 'page-legal-detail',
                    params: { id: item.id }
                  }"
                  >{{ item[h.value] }}</router-link
                >
              </div>
              <div v-else-if="h.type === 'date'">
                <DateTimeCell :value="item[h.value]" />
              </div>
              <div v-else-if="h.type === 'boolean'">
                <v-icon
                  v-text="'mdi-checkbox-marked-circle'"
                  :color="item[h.value] ? 'success' : 'grey'"
                />
              </div>
              <div v-else-if="h.type === 'actions'">
                <router-link
                  :to="{
                    name: 'page-legal-detail',
                    params: { id: item.id }
                  }"
                  title="Редактировать"
                  ><v-btn icon><v-icon>mdi-pencil</v-icon></v-btn></router-link
                >
                <a title="Удалить">
                  <v-btn icon @click="deleteLegalDetails(item.id)">
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </a>
              </div>
              <div v-else>
                {{ get(item, h.value) }}
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </DataTableWrapper>
    <ConfirmationDialog ref="confirmDetailRemoving" />
  </div>
</template>

<script>
import DataTableWrapper from '@/components/data-table-wrapper/DataTableWrapper'
import DataTableFilters from '@/components/data-table-filters/DataTableFilters'
import ConfirmationDialog from '@/components/confirmation-dialog/ConfirmationDialog'
import DateTimeCell from '@/components/date-time-cell/DateTimeCell'
import { gridDependentMixin } from '@/pages/grid-dependent.mix'
import perPage from '@/configs/v-data-table.js'
import headersConfig from './headersConfig'
import { get, formatAmount, formatDate } from '@/utils'
import deleteLegalDetails from '@/services/gql/types/LegalDetail/mutations/deleteLegalDetail.graphql'

export default {
  gridType: 'legalDetails',
  headersConfig,
  perPage,
  mixins: [gridDependentMixin],
  components: { ConfirmationDialog, DateTimeCell, DataTableFilters, DataTableWrapper },
  name: 'GridLegalDetails',
  methods: {
    get,
    formatDate,
    formatAmount,
    async deleteLegalDetails (id) {
      try {
        await this.$refs.confirmDetailRemoving.open()
        await this.$async.deleteLegalDetail.$perform(id)
        this.$successMsg('Анкета удалена')
        this.refetch()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении анкеты с ID ${id}`)
      }
    }
  },
  computed: {
    filters () {
      return {
        id: { control: 'text', modifier: 'contains' },
        name: { control: 'text', modifier: 'contains' },
        title: { control: 'text', modifier: 'contains' },
        orgType: { control: 'text', modifier: 'contains' },
        surname: { control: 'text', modifier: 'contains' },
        patronymic: { control: 'text', modifier: 'contains' },
        position: { control: 'text', modifier: 'contains' },
        phone: { control: 'text', modifier: 'contains' },
        email: { control: 'text', modifier: 'contains' },
        inn: { control: 'text', modifier: 'contains' },
        ogrn: { control: 'text', modifier: 'contains' },
        legalAddress: { control: 'text', modifier: 'contains' },
        mailAddress: { control: 'text', modifier: 'contains' },
        bank: { control: 'text', modifier: 'contains' },
        checkingAcc: { control: 'text', modifier: 'contains' },
        bic: { control: 'text', modifier: 'contains' },
        createdAt: { control: 'date-range' }
      }
    }
  },
  async: {
    deleteLegalDetail (id) {
      return this.$apollo.mutate({
        mutation: deleteLegalDetails,
        variables: {
          id
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
